// Activity feed API + types.
//
// Wire types come from the backend OpenAPI codegen
// (`components["schemas"]["ActivityLogResponse"]`); the query shape uses
// the codegen's `ActivityListQuery` schema 1:1.

import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/api-client";
import type { components } from "@/types/api";
import type { PageResponse } from "@/types/property";

export type ActivityLogResponse = components["schemas"]["ActivityLogResponse"];
export type ActivityListQuery = components["schemas"]["ActivityListQuery"];

export const activityKeys = {
  all: ["activities"] as const,
  lists: () => [...activityKeys.all, "list"] as const,
  list: (query: ActivityListQuery) => [...activityKeys.lists(), query] as const,
};

function buildActivityPath(query: ActivityListQuery): string {
  const params = new URLSearchParams();
  if (query.entityType !== undefined) params.set("entityType", query.entityType);
  if (query.entityId !== undefined) params.set("entityId", String(query.entityId));
  if (query.actorUserId !== undefined)
    params.set("actorUserId", String(query.actorUserId));
  if (query.since !== undefined) params.set("since", query.since);
  if (query.page !== undefined) params.set("page", String(query.page));
  if (query.size !== undefined) params.set("size", String(query.size));
  const qs = params.toString();
  return qs ? `/activities?${qs}` : "/activities";
}

export function useActivities(query: ActivityListQuery) {
  return useQuery({
    queryKey: activityKeys.list(query),
    queryFn: () =>
      apiRequest<PageResponse<ActivityLogResponse>>(buildActivityPath(query)),
    placeholderData: (prev) => prev,
  });
}
